(() => {
  if (window.headerSubmenuCarousel) return;

  const sliderSelector = '.js-header-submenu-swiper';
  const carouselSelector = '.js-header-submenu-carousel';
  const boundDetails = new WeakSet();

  const bindDetailsToggle = (sliderElement) => {
    const details = sliderElement.closest('details');
    if (!details || boundDetails.has(details)) return;

    boundDetails.add(details);
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      window.requestAnimationFrame(() => window.swiperFunctions.update(sliderElement));
    });
  };

  const initializeCarousel = (sliderElement) => {
    const carousel = sliderElement.closest(carouselSelector);
    if (!carousel) return null;

    const prevEl = carousel.querySelector('.js-header-submenu-prev');
    const nextEl = carousel.querySelector('.js-header-submenu-next');

    const instance = window.swiperFunctions.init(sliderElement, {
      slidesPerView: 6,
      spaceBetween: 20,
      loop: true,
      navigation: { prevEl, nextEl }
    });

    if (instance) bindDetailsToggle(sliderElement);
    return instance;
  };

  const destroyCarousel = (sliderElement) => {
    window.swiperFunctions.destroy(sliderElement);
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll?.(sliderSelector).forEach(initializeCarousel);
  };

  const destroyAll = (scope = document) => {
    scope.querySelectorAll?.(sliderSelector).forEach(destroyCarousel);
  };

  const boot = () => {
    initializeAll();

    window.swiperFunctions.bindShopifyEditor({
      sliderSelector,
      initialize: initializeCarousel,
      destroyElement: destroyCarousel,
      onSectionLoad(event) {
        initializeAll(event.target);
      },
      onSectionUnload(event) {
        destroyAll(event.target);
      }
    });
  };

  if (window.swiperFunctions) {
    boot();
  } else {
    document.addEventListener('swiper-functions:ready', boot, { once: true });
  }

  window.headerSubmenuCarousel = { initializeAll };
})();
